import type { CVideoGalleryOuterTranslations } from "./pl";

export const en: CVideoGalleryOuterTranslations = {
  emptyData: "No data to display.",
  emptyList: "No videos match the search criteria.",
  searchPlaceholder: "Search...",
  backToList: "<- Back to the video list",
  unsupportedVideo: "Open video in a new window",
  paginationLabel: (page: number, totalPages: number) =>
    `Page ${page} of ${totalPages}`,
  prevPage: "Previous",
  nextPage: "Next",
};
